import { get, post, delete as axiosDelete } from 'axios';
import {
  HOME_PLAYLIST_ENDPOINT,
  HISTORY_ENDPOINT,
  SEARCH_ENDPOINT,
  SEARCH_GENRE_ENDPOINT,
  RECENT_SEARCH_ENDPOINT,
  VIDEO_DETAIL_ENDPOINT,
  ADD_DEVICE_ENDPOINT,
  BANNER_ENDPOINT,
  PROGRAMME_GUIDES,
  ARTICLES_ENDPOINT,
  ARTICLES_RECOMMENDED_ENDPOINT,
  ARTICLES_RELATED_ENDPOINT
} from './endpoints';
import utils from './util';

import { endpoints } from '@source/config';
import DRMConfig from '@source/lib/DRMConfig';

const getHomePlaylist = (pathName = 'pyl1552884', token = '') => {
  return get(`${HOME_PLAYLIST_ENDPOINT}/${pathName}`, {
    ...endpoints.setting
    // headers: token && { Authorization: `Bearer ${token}` }
  })
    .then(response => {
      const result = utils.normalizeHomePlaylist(response);
      return {
        meta: {
          status: result ? 'success' : 'no_result',
          error: ''
        },
        data: result || []
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `home/getHomePlaylist - ${error}`
        },
        data: []
      };
    });
};

const getListPlaylist = (playlistId, token) => {
  return get(`${HOME_PLAYLIST_ENDPOINT}/${playlistId}`, {
    ...endpoints.setting
    // headers: token && { Authorization: `Bearer ${token}` }
  }).then(response => {
    const result = utils.normalizeHomePlaylist(response);
    return result || [];
  });
};

const getVideosPlaylist = (playlistId, token) => {
  return get(`${HOME_PLAYLIST_ENDPOINT}/${playlistId}`, {
    ...endpoints.setting
    // headers: token && { Authorization: `Bearer ${token}` }
  }).then(response => {
    const result = utils.normalizeHomeVideo(response);
    return result[0] || [];
  });
};

const getVodPlaylist = (playlistId, token) => {
  return get(`${HOME_PLAYLIST_ENDPOINT}/${playlistId}`, {
    ...endpoints.setting
    // headers: token && { Authorization: `Bearer ${token}` }
  }).then(response => {
    const result = utils.normalizeVodPlaylist(response);
    return result;
    // if (result.playlists && result.playlists.length > 0) {
    //   return { playlists: result.playlists };
    // }
    // return { videos: result.videos ? result.videos : [] };
    // return result[0] || []
    // if (response.data.data[0].attributes.videos) {
    //   const result = utils.normalizeVODVideo(response);
    //   return { videos: result[0] || [] };
    // } else {
    //   const result = utils.normalizeVODPlaylist(response);
    //   return { playlists: result[0] || [] };
    // }
  });
};

const getHomeVideo = (id, token) => {
  return get(`${HOME_PLAYLIST_ENDPOINT}/${id}`, {
    ...endpoints.setting
    // headers: token && { Authorization: `Bearer ${token}` }
  })
    .then(response => {
      const result = utils.normalizeHomeVideo(response);
      return {
        meta: {
          status: 'success',
          error: ''
        },
        data: [...result[0]] || []
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `home/getHomeVideo - ${error}`
        },
        data: []
      };
    });
};

const getMatchVideoId = (id, token) => {
  return get(`${HOME_PLAYLIST_ENDPOINT}/${id}`, {
    ...endpoints.setting
    // headers: token && { Authorization: `Bearer ${token}` }
  })
    .then(response => {
      const result = utils.normalizeVideoIdList(response);
      return {
        meta: {
          status: 'success',
          error: ''
        },
        data: [...result[0]] || []
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `match/getMatchVideoId - ${error}`
        },
        data: []
      };
    });
};

const getMatchDetail = (videoIdList, token) => {
  return post(
    `${VIDEO_DETAIL_ENDPOINT}/`,
    {
      videos: videoIdList
    },
    {
      ...endpoints.setting
      // headers: token && { Authorization: `Bearer ${token}` }
    }
  )
    .then(response => {
      const result = utils.normalizeMatchDetail(response);
      return {
        meta: {
          status: 'success',
          error: ''
        },
        data: result || []
      };
    })
    .catch(error => {
      return {
        meta: {
          status,
          error: `match/getMatchDetail - ${error}`
        },
        data: []
      };
    });
};

const getAllHistory = ({ userId }) => {
  return get(`${HISTORY_ENDPOINT}/${userId}/videos/histories`, {
    ...endpoints.setting
  })
    .then(response => {
      const result = utils.normalizeHistory(response);
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result'
        },
        data: [...result] || []
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          text: `history/getAllHistory - ${error}`
        },
        data: []
      };
    });
};

const getSearchResult = ({ q }) => {
  return get(`${SEARCH_ENDPOINT}`, {
    params: { q: q },
    ...endpoints.setting
  })
    .then(response => {
      const result = utils.normalizeSearchResult(response);
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: ''
        },
        data: [...result] || []
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `search/getSearchResult - ${error}`
        },
        data: []
      };
    });
};

const getSearchGenre = payload => {
  return get(`${SEARCH_GENRE_ENDPOINT}`, {
    ...endpoints.setting
  })
    .then(response => {
      const result = utils.normalizeSearchGenre(response);
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: ''
        },
        data: [...result[0]] || []
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `search/getSearchGenre - ${error}`
        },
        data: []
      };
    });
};

const getRecentSearch = (sessionId, sid) => {
  return get(`${RECENT_SEARCH_ENDPOINT}`, {
    params: { sessionId: sessionId },
    ...endpoints.setting,
    headers: { Authorization: `Bearer ${sid}` }
  })
    .then(response => {
      const result = utils.normalizeRecentSearch(response);
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: ''
        },
        data: result.length > 0 ? [...result] : []
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `search/getRecentSearch - ${error}`
        },
        data: []
      };
    });
};

const postRecentSearch = (sessionId, sid, keyword) => {
  post(
    `${RECENT_SEARCH_ENDPOINT}?sessionId=${sessionId}&q=${keyword}`,
    {},
    {
      ...endpoints.setting,
      headers: { Authorization: `Bearer ${sid}` }
    }
  )
    .then(result => {
      return {
        meta: {
          status: 'success',
          error: ''
        }
      };
    })
    .catch(err => {
      return {
        meta: {
          status: 'error',
          error: 'Error add recent search ' + err
        }
      };
    });
};

const deleteRecentSearchAll = (sessionId, sid) => {
  return axiosDelete(`${RECENT_SEARCH_ENDPOINT}?sessionId=${sessionId}`, {
    ...endpoints.setting,
    headers: { Authorization: `Bearer ${sid}` }
  })
    .then(result => {
      return {
        meta: {
          status: 'success',
          error: ''
        }
      };
    })
    .catch(err => {
      return {
        meta: {
          status: 'error',
          error: err
        }
      };
    });
};

const deleteRecentSearch = (sessionId, sid, keyword) => {
  return axiosDelete(
    `${RECENT_SEARCH_ENDPOINT}?sessionId=${sessionId}&q=${keyword}`,
    {
      ...endpoints.setting,
      headers: { Authorization: `Bearer ${sid}` }
    }
  )
    .then(result => {
      return {
        meta: {
          status: 'success',
          error: ''
        }
      };
    })
    .catch(err => {
      return {
        meta: {
          status: 'error',
          error: err
        }
      };
    });
};

const getVideoDetail = ({ id, token }) => {
  return get(`${VIDEO_DETAIL_ENDPOINT}/${id}`, {
    ...endpoints.setting
    // headers: token && { Authorization: `Bearer ${token}` }
  })
    .then(response => {
      const result = utils.normalizeVideoDetail(response);
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: ''
        },
        data: result[0] || []
      };
    })
    .catch(error => {
      const errorMessage = error
        .toString()
        .replace('Error:', 'sstv Video Detail');
      return {
        meta: {
          status: 'error',
          error: errorMessage
        },
        data: []
      };
    });
};

const getMovieLibrary = (id, token) => {
  return get(`${HOME_PLAYLIST_ENDPOINT}/${id}`, {
    ...endpoints.setting
    // headers: token && { Authorization: `Bearer ${token}` }
  })
    .then(response => {
      const result = utils.normalizeMovieLibrary(response);
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: ''
        },
        data: [...result[0]] || []
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `search/getMovieLibrary - ${error}`
        },
        data: []
      };
    });
};

const getProgramGuides = (date, playlistId, token) => {
  return get(`${PROGRAMME_GUIDES}/${date}/playlists/${playlistId}`, {
    ...endpoints.setting
    // headers: token && { Authorization: `Bearer ${token}` }
  })
    .then(response => {
      const result = utils.normalizeProgrammeGuides(response);
      return {
        meta: {
          status: 'success',
          error: ''
        },
        data: result
      };
    })
    .catch(error => {
      if (error.response.status == '404') {
        return {
          meta: {
            status: '404',
            error: error.response.data
          },
          data: []
        };
      } else {
        const errorMessage = error
          .toString()
          .replace('Error:', 'sstv Programme Guides');
        return {
          meta: {
            status: 'error',
            error: errorMessage
          },
          data: []
        };
      }
    });
};

const getSeriesDetail = (playlistId, token) => {
  return get(`${HOME_PLAYLIST_ENDPOINT}/${playlistId}`, {
    ...endpoints.setting
    // headers: token && { Authorization: `Bearer ${token}` }
  })
    .then(response => {
      const result = utils.normalizeSeriesVideos(response);
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: ''
        },
        data: result[0] || []
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `series/getSeriesDetail - ${error}`
        },
        data: []
      };
    });
};

const getBanner = (pathName, token) => {
  return get(`${BANNER_ENDPOINT}/${pathName}`, {
    ...endpoints.setting
    // headers: token && { Authorization: `Bearer ${token}` }
  })
    .then(response => {
      const result = utils.normalizeBanner(response);
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: ''
        },
        data: result || []
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `banner/getBanner - ${error}`
        },
        data: []
      };
    });
};

const getVUID = ({ deviceId, r }) => {
  let urlParam = `deviceId=${deviceId}`;

  if (r === 1) {
    urlParam = `r=1`;
  }

  return get(`${ADD_DEVICE_ENDPOINT}?${urlParam}`, {
    ...endpoints.setting
  })
    .then(response => {
      const vuid = response.data.data.attributes.vuid;
      return {
        meta: {
          status: vuid ? 'success' : 'no_vuid',
          error: ''
        },
        data: vuid || null
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `vuid/getVUID - ${error}`
        },
        data: null
      };
    });
};

const getArticlesDetail = (pathName, token) => {
  return get(`${ARTICLES_ENDPOINT}/${pathName}`, {
    ...endpoints.setting
    // headers: token && { Authorization: `Bearer ${token}` }
  })
    .then(response => {
      const result = utils.normalizeArticlesDetail(response);
      return {
        meta: {
          status: result ? 'success' : 'no_result',
          error: ''
        },
        data: result || null
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `articlesDetail/getArticlesDetail - ${error}`
        },
        data: null
      };
    });
};

const getRecommendedArticles = (pathName, token) => {
  return get(`${ARTICLES_RECOMMENDED_ENDPOINT}/${pathName}`, {
    ...endpoints.setting
    // headers: token && { Authorization: `Bearer ${token}` }
  })
    .then(response => {
      const result = utils.normalizeRecommendedArticles(response);
      return {
        meta: {
          status: result ? 'success' : 'no_result',
          error: ''
        },
        data: result || []
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `recommendedArticles/getRecommendedArticles - ${error}`
        },
        data: []
      };
    });
};

const getArticlesByCategory = (
  pathName,
  page = 1,
  size = 10,
  order = 'desc',
  token
) => {
  return get(
    `${ARTICLES_RECOMMENDED_ENDPOINT}/${pathName}?page=${page}&size=${size}&order=${order}`,
    {
      ...endpoints.setting
      // headers: token && { Authorization: `Bearer ${token}` }
    }
  )
    .then(response => {
      const result = utils.normalizeRecommendedArticles(response);
      return {
        meta: {
          status: result ? 'success' : 'no_result',
          error: ''
        },
        data: result || []
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `recommendedArticles/getArticlesByCategory - ${error}`
        },
        data: []
      };
    });
};

const getRelatedArticles = (articlesId, token) => {
  return get(`${ARTICLES_RELATED_ENDPOINT}/${articlesId}`, {
    ...endpoints.setting
    // headers: token && { Authorization: `Bearer ${token}` }
  })
    .then(response => {
      const result = utils.normalizeRecommendedArticles(response);
      return {
        meta: {
          status: result ? 'success' : 'no_result',
          error: ''
        },
        data: result || []
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `relatedArticles/getRelatedArticles - ${error}`
        },
        data: []
      };
    });
};

const getNewArticles = () => {
  return get(`${ARTICLES_ENDPOINT}?size=8&order=desc`, {
    ...endpoints.setting
  })
    .then(response => {
      const result = utils.normalizeNewArticles(response);
      return {
        meta: {
          status: result ? 'success' : 'no_result',
          error: ''
        },
        data: result || []
      };
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: `newArticles/getNewArticles - ${error}`
        },
        data: []
      };
    });
};

export default {
  getHomePlaylist,
  getHomeVideo,
  getAllHistory,
  getSearchResult,
  getSearchGenre,
  getRecentSearch,
  postRecentSearch,
  deleteRecentSearch,
  deleteRecentSearchAll,
  getVideoDetail,
  getMovieLibrary,
  // getMovieStream,
  getSeriesDetail,
  getListPlaylist,
  getVideosPlaylist,
  getVodPlaylist,
  getBanner,
  getProgramGuides,
  getVUID,
  getArticlesDetail,
  getRecommendedArticles,
  getRelatedArticles,
  getMatchDetail,
  getMatchVideoId,
  getArticlesByCategory,
  getNewArticles
  // getMovieStream
};
